import React from 'react';
import { OTPVerifyForm } from './OTPVerifyForm';

type Props = {
  phoneNumber: string;
  userLoginId: string;
  onBack: () => void;
  onSuccess: () => void;
};

export const OnboardingPhoneVerify = ({
  phoneNumber,
  userLoginId,
  onBack,
  onSuccess,
}: Props) => {
  return (
    <OTPVerifyForm
      phoneNumber={phoneNumber}
      userLoginId={userLoginId}
      onBack={onBack}
      onSuccess={onSuccess}
    />
  );
};